import type { SeedDependencyInfo } from '../api/SeedDependencyCard';
import type { WorkflowNode } from '../../../../types/workflow';

export const deriveSeedDependencies = (nodes: WorkflowNode[]): SeedDependencyInfo[] =>
  nodes
    .filter((node) => node.type === 'seed' && node.data?.seedWorkflowId)
    .map((node) => ({
      nodeId: node.id,
      seedWorkflowId: node.data.seedWorkflowId as string,
      seedWorkflowName: (node.data.seedWorkflowName as string | null) ?? null,
      snapshotVersion: (node.data.snapshotVersion as number | null) ?? null,
      onFailure: (node.data.onFailure as 'block' | 'warn') ?? 'block',
    }));

export const hasSingleApiSequenceExecutableNode = (nodes: WorkflowNode[]): boolean => {
  const executableNodes = nodes.filter(
    (node) => node.type !== 'end' && node.type !== 'setup' && node.type !== 'seed'
  );

  return executableNodes.length === 1 && executableNodes[0]?.type === 'api_sequence';
};
